import React from 'react';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import styled from 'styled-components';

export default function BannerSlider({ getAutoPlaySpeed }) {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: getAutoPlaySpeed(),
    speed: 1000,
  };

  return (
    <StyledBannerSlider>
      <Slider {...settings}>
        <StyledCrew1 />
        <StyledCrew2 />
      </Slider>
    </StyledBannerSlider>
  );
}
const StyledBannerSlider = styled.div`
  margin: 0 auto;

  button {
    display: none;
  }

  ${({ theme }) => theme.mobile`
  margin: 0 auto;
  `}
`;
const StyledCrew1 = styled.div`
  height: 876px;
  background-image: url('images/About/banner/crew1-1.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  ${({ theme }) => theme.mobile`
  height: 100vh;
    
  `}
`;

const StyledCrew2 = styled(StyledCrew1)`
  background-image: url('images/About/banner/crew2-1.png');
`;
